export default __webpack_public_path__ + "static/media/burger.c3b03e2e.png";